import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { InsightsCell } from "@/molecules/InsightsCell"
import { checkInsightValue } from "@/molecules/InsightsIcons"

import type { TFunction } from "@/hooks/useTranslation"
import type { InsightsValues } from "."

export const InsightsTriageCell = (
  t: TFunction,
  internetFacingFF?: boolean,
  isDemo?: boolean
) =>
  function InsightsTriageCellComponent({
    tag,
    id,
    ...values
  }: Partial<InsightsValues>) {
    const runtimeIcon = checkInsightValue(values.executed ?? false)
      ? ICONS_INSIGHTS.functionExecuted
      : ICONS_INSIGHTS.runtime

    const items = [
      runtimeIcon,
      ICONS_INSIGHTS.exploitability.IN_THE_WILD,
      ICONS_INSIGHTS.ingress,
      ICONS_INSIGHTS.exploitability.POC,
      ICONS_INSIGHTS.isDevDependency,
      ICONS_INSIGHTS.aiInsight
    ]

    if (internetFacingFF) {
      items.splice(1, 0, ICONS_INSIGHTS.internetFacing)
    }

    if (isDemo) items.unshift(ICONS_INSIGHTS.exploitable)

    return (
      <InsightsCell
        hide
        id={id}
        items={items}
        values={values}
        t={t}
        tag={tag}
      />
    )
  }
